// @greenlight-spec: 17-code-organization.md
// @greenlight-spec: 15-database-schema.md
/**
 * The clouds an install can actually run on. Separate from `CLOUD_PROVIDERS`
 * because `localfake` is a configuration choice, not a cloud: health reporting
 * has to be able to say "this install runs on Azure" without the local stack
 * being one of the answers.
 */
export const INSTALL_CLOUD_PROVIDERS = ['azure', 'gcp', 'aws'];
export const CLOUD_PROVIDERS = [...INSTALL_CLOUD_PROVIDERS, 'localfake'];
export const SCM_PROVIDERS = ['github', 'gitlab', 'bitbucket', 'localfake'];
// Control-plane notification email transport (docs/11 §Notification Delivery).
// Chosen by its own config key — the same shape as SCM_PROVIDERS — not derived
// from CLOUD_PROVIDERS: GCP has no first-party transactional email service, and
// an Azure install may prefer its own relay over provisioning ACS.
export const EMAIL_TRANSPORTS = ['acs', 'smtp', 'none'];
//# sourceMappingURL=providers.js.map